import { call, put } from 'redux-saga/effects'
import { RequestMethods } from 'utils/axios/methods'
import type { PayloadAction } from '@reduxjs/toolkit'
import { Actions_CurrentTrailer } from 'redux/modules/currentTrailer/Actions'
import { sagaAction_Error } from 'redux/sagas/actions/SagaAction_Error'
import { Actions_Notifications } from 'redux/modules/notification/Actions'
import { SagaWorker_LoadTrailersList } from 'redux/sagas'

const { remove } = RequestMethods()

export interface ISagaWorker_DeleteTrailerFromTrailersList {
  id: number
}

export default function* SagaWorker_DeleteTrailerFromTrailersList(
  action: PayloadAction<ISagaWorker_DeleteTrailerFromTrailersList>,
) {
  const { id } = action.payload
  yield put(Actions_CurrentTrailer.store.showLoader())

  try {
    //------------------------- Remove trailer ---------------------------//
    yield call(async () => await remove(`/trailers/${id}`))

    yield put(Actions_CurrentTrailer.store.clearSelectedTrailerInfo())
    yield call(SagaWorker_LoadTrailersList)

    yield put(Actions_Notifications.store.setNotification({ message: 'Trailer deleted successfully', type: 'Success' }))
  } catch (e) {
    yield call(() => sagaAction_Error(e))
  } finally {
    yield put(Actions_CurrentTrailer.store.hideLoader())
  }
}
